"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.logoutFailure = exports.logoutSuccess = exports.logoutRequest = exports.loginFailure = exports.loginSuccess = exports.loginRequest = void 0;
const types = require("./types");
const loginRequest = (jwt) => ({
    jwt,
    type: types.LOGIN_REQUEST
});
exports.loginRequest = loginRequest;
const loginSuccess = (request) => (Object.assign({ type: types.LOGIN_SUCCESS }, request));
exports.loginSuccess = loginSuccess;
const loginFailure = (errorMessage) => ({
    errorMessage,
    type: types.LOGIN_FAILURE
});
exports.loginFailure = loginFailure;
const logoutRequest = () => ({
    type: types.LOGOUT_REQUEST
});
exports.logoutRequest = logoutRequest;
const logoutSuccess = () => ({
    type: types.LOGOUT_SUCCESS
});
exports.logoutSuccess = logoutSuccess;
const logoutFailure = (errorMessage) => ({
    errorMessage,
    type: types.LOGOUT_FAILURE
});
exports.logoutFailure = logoutFailure;
//# sourceMappingURL=actions.js.map